<code-input
    #inner
    [codeLength]="codeLength"
    [inputType]="inputType"
    [attr.inputmode]="inputMode || null"
    [initialFocusField]="initialFocusField"
    [isNonDigitsCode]="isNonDigitsCode"
    [isCharsCode]="isCharsCode"
    [isCodeHidden]="isCodeHidden"
    [isPrevFocusableAfterClearing]="isPrevFocusableAfterClearing"
    [isFocusingOnLastByClickIfFilled]="isFocusingOnLastByClickIfFilled"
    [code]="code"
    [disabled]="disabled"
    [autocapitalize]="autocapitalize"
    (codeChanged)="codeChanged.emit($event)"
    (codeCompleted)="codeCompleted.emit($event)"
></code-input>
